import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ApiResponse} from '../classes/api-response';
import {cloneDeep} from 'lodash-es';
import {AuthService} from './auth.service';
import {Router} from '@angular/router';
import {MatDialog} from "@angular/material/dialog";

@Injectable({
  providedIn: 'root'
})
export class GeneralInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService,
    private router: Router,
    private dialogService: MatDialog) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError((err: HttpErrorResponse) => {

          if (err.status == 401) {
            this.authService.clearUser();
            return EMPTY;
          }

          if (err.error) {
            return throwError(cloneDeep<ApiResponse>(err.error));
          } else {
            const ret = new ApiResponse();
            ret.errors = ['aw.api.errors.generic'];
            return throwError(ret);
          }
        }));
  }
}
